export default {
  cardholder_name: 'Volledige naam',
  cardholder_name_placeholder: 'Naam op kaart',
  card_number: 'Kaartnummer',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Vervaldatum',
  expiry_placeholder: 'MM / JJ',
  cvv: 'Beveiligingscode',
  cvv_label: 'Beveiligingscode (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Beveiligd betaalformulier initialiseren…',
  sdk_load_failed:
    'Het beveiligde betaalformulier kon niet worden geladen. Controleer je verbinding en vernieuw de pagina.',
  errors: {
    number_blank: 'Voer je kaartnummer in.',
    number_invalid: 'Dit kaartnummer is niet geldig. Controleer de cijfers en probeer het opnieuw.',
    number_incomplete: 'Je kaartnummer is onvolledig.',
    cvv_blank: 'Voer de beveiligingscode op de achterkant van je kaart in.',
    cvv_invalid: 'Deze beveiligingscode is niet geldig. Controleer de 3 of 4 cijfers op je kaart.',
    cvv_incomplete: 'Voer alle {{count}} cijfers van je beveiligingscode in.',
    expiry_invalid: 'Voer een geldige vervaldatum in als MM / JJ.',
    expired: 'Deze kaart is verlopen. Gebruik een andere kaart.',
    name_blank: 'Voer de naam exact in zoals deze op je kaart staat.',
    configuration: 'Kaartbetalingen zijn momenteel niet beschikbaar. Probeer een andere betaalmethode.',
    generic: 'We konden je kaartgegevens niet controleren. Probeer het opnieuw.',
  },
};
